import React, { useContext, useState } from "react";
import config from "src/config";
import { ThemeProvider } from "styled-components";
import { ColorMode } from "../theme";

export const ThemeContext = React.createContext<{
  headerReturn: boolean;
  headerUser: boolean;
  setHeaderReturn: (active: boolean) => void;
  setHeaderUser: (active: boolean) => void;
  mode: ColorMode;
}>({
  headerReturn: true,
  headerUser: true,
  setHeaderReturn: (active: boolean) => {},
  setHeaderUser: (active: boolean) => {},
  mode: config.THEME_MODE,
});

export const ThemeContextProvider = ({ children }: any) => {
  const [headerReturn, setHeaderReturn] = useState(true);
  const [headerUser, setHeaderUser] = useState(true);
  const mode = config.THEME_MODE;

  return (
    <ThemeContext.Provider
      value={{
        headerReturn,
        headerUser,
        setHeaderReturn,
        setHeaderUser,
        mode,
      }}
    >
      <ThemeProvider theme={{ mode }}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => useContext(ThemeContext);
